// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebaseConfig: {
    apiKey: "AIzaSyAJpx185jCgz-i_QQju6XO1OqWEuzf9z4I",
    authDomain: "gleemo-1a066.firebaseapp.com",
    projectId: "gleemo-1a066",
    storageBucket: "gleemo-1a066.appspot.com",
    messagingSenderId: "193302919466",
    appId: "1:193302919466:web:063fbc283d6f07ef928653",
    measurementId: "G-74W6NVYKDK"
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
